import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuCategoryActions } from "./apu-category.actions";
import { ApuCategoryApiModel } from "@/core/models/api/apu-category-api.model";
import { ApuCategoryService } from "@/core/services/apu-category.service";

@Injectable()
export class ApuCategoryEffects {
    actions$ = inject(Actions);
    apuCategoryService = inject(ApuCategoryService);

    constructor(){

    }

    _loadApuCategoryList = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuCategoryActions.loadApuCategories),
            exhaustMap(() => {
                return this.apuCategoryService.getAll().pipe(
                    map((response: any) => {
                        const apuCategories = response as ApuCategoryApiModel[];
                        return ApuCategoryActions.loadApuCategorySuccess({ apuCategories });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuCategoryActions.addRangeApuCategories),
            exhaustMap((action) => {
                return this.apuCategoryService.addRange(action.apuCategories).pipe(
                    map((response: any) => {
                        const apuCategories = response as ApuCategoryApiModel[];
                        return ApuCategoryActions.addRangeApuCategorySuccess({ apuCategories });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}